export const getActiveAgent = (agents, policy) => {
  return agents.filter((agent) =>
    policy?.agentStatusInfo?.some(
      (agentStatus) =>
        agent.agentNumber === agentStatus.agentNumber &&
        agentStatus.status === "A"
    )
  );
};
